import React from 'react';
import {dsnCN} from "../../../hooks/helper";

function MenuContent({className}) {
    const socialData = [
        {link: "#0", name: "Linkedin."},
        {link: "#0", name: "Facebook."},
        {link: "#0", name: "Instagram."},
    ];
    return (
        <div className={dsnCN('container-content  d-flex flex-column justify-content-center', className)}>
            <div className="nav__info">
                <div className="nav-content">
                    <h5 className="sm-title-block mb-10">Address</h5>
                    <p>
                    5/69, 3rd Main Rd,<br ></br> Kalaimagal Nagar, Ekkatuthangal, <br ></br> Chennai - 600032, India
                    </p>

                </div>
                <div className="nav-content mt-30">
                    <h5 className="sm-title-block mb-10">Contact</h5>
                    <p className="links over-hidden mb-1">
                        <a className="link-hover" href="tel:+00 (2)012 3321" data-hover-text="+91 98842 54666">
                       
                        (+91) 98842 54666
                        </a>
                    </p>
                    <p className="links over-hidden">
                        <a className="link-hover" href="mailto:sasi@tagzen.in"
                           data-hover-text="sasi@tagzen.in">sasi@tagzen.in</a>
                    </p>
                </div>
            </div>
            <div className="nav-social nav-content mt-30">
                <div className="nav-social-inner p-relative">
                    <h5 className="sm-title-block mb-10">Follow us</h5>
                    <ul>
                        {socialData.map((item, index) =>
                            <li key={index}>
                                <a href={item.link} target="_blank" rel="nofollow noopener noreferrer">{item.name}</a>
                            </li>)}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MenuContent;